import { EventRepository } from '../repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { Event } from '../domain/entities/Event';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class StoreTownSelectedUseCase {
    private eventRepository: EventRepository;
    private town: string;

    constructor(town: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.town = town;
    }

    public execute = async () => {
        const storeTownSelectedPayload = {
            event_name: 'store town selected',
            event_action: 'store town selected',
            event_label: `${this.town}`
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.STORE_LOCATION_SELECTED,
            type: 'link',
            payload: storeTownSelectedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
